/* eslint-disable no-unused-expressions */
/* eslint-disable array-callback-return */
/* eslint-disable class-methods-use-this */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable max-len */
/* eslint-disable camelcase */
/* eslint-disable react/no-string-refs */
/* eslint-disable react/no-array-index-key */


import React, { Component } from 'react';
import { Card, CardDeck, CardBody, Col, Button, ButtonToolbar, ButtonGroup, ListGroup, ListGroupItem, Table, Input } from 'reactstrap';
import 'react-table/react-table.css';
import axios from 'axios';
import { connect } from 'react-redux';
import ActionButton from './ActionButton';


const currencyFormat = new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP' });
const URL = 'https://marketplace-api.musicmarquee.co.uk';
const ADMIN_URL = 'https://api.musicmarquee.co.uk';
const REQUEST_TIMEOUT_MS = 600000;


class ToolsUpdateOrders extends Component {
  constructor() {
    super();
    this.state = {
      updateOrdersResponse: { complete: false, response: undefined },
      newOrderResponse: { complete: false, response: undefined },
      updateProductsResponse: { complete: false, response: undefined },
      manualOrderResponse: { complete: false, response: undefined },
      shopifyConfigs: [],
      selectedUpdateOrdersStore: 'all',
      selectedNewOrdersStore: 'all',
      selectedProductStore: '',
      selectedManualOrderStore: '',
      manualOrderNumber: '',
    };
  }

  componentDidMount() {
    this.getShopifyConfigs();
  }

  getAxiosConfig() {
    return {
      headers: { Authorization: localStorage.getItem('mm_admin') },
      timeout: REQUEST_TIMEOUT_MS,
    };
  }

  getAdminAxiosConfig() {
    return {
      headers: { Authorization: localStorage.getItem('mm_admin') },
    };
  }

  async getShopifyConfigs() {
    try {
      const response = await axios.post(
        `${ADMIN_URL}/admin/clients/shopify/configs`,
        {},
        this.getAdminAxiosConfig(),
      );

      const shopifyConfigs = response.data.configs || [];

      this.setState({
        shopifyConfigs,
        selectedProductStore: shopifyConfigs.length > 0 ? shopifyConfigs[0].shop_name : '',
        selectedManualOrderStore: shopifyConfigs.length > 0 ? shopifyConfigs[0].shop_name : '',
      });
    } catch (error) {
      this.setState({
        updateProductsResponse: {
          complete: false,
          response: `Unable to load Shopify clients: ${this.getErrorMessage(error)}`,
        },
      });
    }
  }

  getErrorMessage(error) {
    if (!error) return 'Unknown error.';

    if (error.code === 'ECONNABORTED') {
      return 'The request timed out before the server returned a response.';
    }

    if (error.response && error.response.data) {
      const responseData = error.response.data;

      if (typeof responseData === 'string') return responseData;
      if (responseData.error) {
        return typeof responseData.error === 'string'
          ? responseData.error
          : JSON.stringify(responseData.error);
      }
      if (responseData.message) return responseData.message;
      return JSON.stringify(responseData);
    }

    return error.message || 'Unknown error.';
  }

  async getNewShopifyOrders() {
    return this.runShopifyAction({
      responseKey: 'newOrderResponse',
      actionText: 'Getting new Shopify orders',
      task: async () => {
        const response = await axios.post(
          `${URL}/admin/shopify/orders`,
          { store: this.state.selectedNewOrdersStore },
          this.getAxiosConfig(),
        );
        this.setState({
          newOrderResponse: { complete: true, response: this.formatResponse(response.data) },
        });
      },
    });
  }

  formatResponse(responseData) {
    if (Array.isArray(responseData)) {
      return responseData.reduce((p, c) => [p, <br />, c]);
    }

    if (typeof responseData === 'string') {
      return responseData;
    }

    return JSON.stringify(responseData);
  }

  async updateShopifyOrders() {
    return this.runShopifyAction({
      responseKey: 'updateOrdersResponse',
      actionText: 'Updating Shopify orders',
      task: async () => {
        const response = await axios.post(
          `${URL}/admin/shopify/orders/update`,
          { store: this.state.selectedUpdateOrdersStore },
          this.getAxiosConfig(),
        );
        this.setState({
          updateOrdersResponse: { complete: true, response: this.formatResponse(response.data) },
        });
      },
    });
  }

  async fetchManualShopifyOrder() {
    return this.runShopifyAction({
      responseKey: 'manualOrderResponse',
      actionText: 'Fetching Shopify order',
      task: async () => {
        if (!this.state.selectedManualOrderStore) {
          this.setState({
            manualOrderResponse: { complete: false, response: 'Select a Shopify client first.' },
          });
          return;
        }

        if (!this.state.manualOrderNumber) {
          this.setState({
            manualOrderResponse: { complete: false, response: 'Enter an order number first.' },
          });
          return;
        }

        const response = await axios.post(
          `${URL}/admin/shopify/order`,
          {
            store: this.state.selectedManualOrderStore,
            orderId: this.state.manualOrderNumber,
          },
          this.getAxiosConfig(),
        );

        this.setState({
          manualOrderResponse: { complete: true, response: this.formatResponse(response.data) },
        });
      },
    });
  }

  async updateShopifyProducts() {
    return this.runShopifyAction({
      responseKey: 'updateProductsResponse',
      actionText: 'Updating Shopify products',
      task: async () => {
        if (!this.state.selectedProductStore) {
          this.setState({
            updateProductsResponse: { complete: false, response: 'Select a Shopify client first.' },
          });
          return;
        }

        const response = await axios.post(
          `${URL}/admin/shopify/products`,
          { store: this.state.selectedProductStore },
          this.getAxiosConfig(),
        );

        this.setState({
          updateProductsResponse: { complete: true, response: response.data },
        });
      },
    });
  }

  async runShopifyAction({ responseKey, actionText, task }) {
    this.setState({
      [responseKey]: { complete: false, response: `${actionText}...` },
    });

    try {
      await task();
    } catch (error) {
      this.setState({
        [responseKey]: { complete: false, response: this.getErrorMessage(error) },
      });
    }

    return true;
  }

  renderStoreSelect({ value, onChange, includeAll = false }) {
    return (
      <Input
        type="select"
        value={value}
        onChange={onChange}
      >
        {includeAll ? <option value="all">All Stores</option> : null}
        {this.state.shopifyConfigs.length === 0 && !includeAll ? (
          <option value="">No Shopify clients found</option>
        ) : null}
        {this.state.shopifyConfigs.map(config => (
          <option key={config.shop_name} value={config.shop_name}>
            {config.current_client_name ? `${config.current_client_name} - ` : ''}
            {config.shop_name}
          </option>
        ))}
      </Input>
    );
  }

  render() {
    return (
      <Col style={{ height: '100%' }}>
        <Card style={{ width: '100%' }}>
          <CardBody>
            <Table striped bordered hover size="sm">
              <thead>
                <tr>
                  <th>Action</th>
                  <th>Complete</th>
                  <th>Result</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td style={{ width: '20%' }}>
                    <div style={{ marginBottom: 8 }}>
                      {this.renderStoreSelect({
                        value: this.state.selectedUpdateOrdersStore,
                        includeAll: true,
                        onChange: e => this.setState({ selectedUpdateOrdersStore: e.target.value }),
                      })}
                    </div>
                    <ActionButton
                      color="primary"
                      size="sm"
                      title="Update Shopify Orders"
                      task={() => this.updateShopifyOrders()}
                    />
                  </td>
                  <td style={{ width: '10%' }}>{this.state.updateOrdersResponse.complete ? 'Complete' : 'Not Complete'}</td>
                  <td style={{ width: '70%' }}>{this.state.updateOrdersResponse.response || ''}</td>
                </tr>
                <tr>
                  <td>
                    <div style={{ marginBottom: 8 }}>
                      {this.renderStoreSelect({
                        value: this.state.selectedNewOrdersStore,
                        includeAll: true,
                        onChange: e => this.setState({ selectedNewOrdersStore: e.target.value }),
                      })}
                    </div>
                    <ActionButton
                      color="primary"
                      size="sm"
                      title="Get New Shopify Orders"
                      task={() => this.getNewShopifyOrders()}
                    />
                  </td>
                  <td>{this.state.newOrderResponse.complete ? 'Complete' : 'Not Complete'}</td>
                  <td>{this.state.newOrderResponse.response || ''}</td>
                </tr>
                <tr>
                  <td>
                    <div style={{ marginBottom: 8 }}>
                      {this.renderStoreSelect({
                        value: this.state.selectedProductStore,
                        onChange: e => this.setState({ selectedProductStore: e.target.value }),
                      })}
                    </div>
                    <ActionButton
                      color="primary"
                      size="sm"
                      title="Update Products"
                      task={() => this.updateShopifyProducts()}
                    />
                  </td>
                  <td>{this.state.updateProductsResponse.complete ? 'Complete' : 'Not Complete'}</td>
                  <td>{this.state.updateProductsResponse.response || ''}</td>
                </tr>
                <tr>
                  <td>
                    <div style={{ marginBottom: 8 }}>
                      {this.renderStoreSelect({
                        value: this.state.selectedManualOrderStore,
                        onChange: e => this.setState({ selectedManualOrderStore: e.target.value }),
                      })}
                    </div>
                    <div style={{ marginBottom: 8 }}>
                      <Input
                        type="text"
                        placeholder="Order number"
                        value={this.state.manualOrderNumber}
                        onChange={e => this.setState({ manualOrderNumber: e.target.value })}
                      />
                    </div>
                    <ActionButton
                      color="primary"
                      size="sm"
                      title="Fetch Shopify Order"
                      task={() => this.fetchManualShopifyOrder()}
                    />
                  </td>
                  <td>{this.state.manualOrderResponse.complete ? 'Complete' : 'Not Complete'}</td>
                  <td>{this.state.manualOrderResponse.response || ''}</td>
                </tr>
              </tbody>
            </Table>
          </CardBody>
        </Card>
      </Col>
    );
  }
}

const mapStateToProps = state => ({
  user: state.auth.user,
});

// export default connect()(SidebarContent);
export default connect(mapStateToProps)(ToolsUpdateOrders);
